import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { ProductQualityModel } from '../models/product-quality.model';
import { ProductModel } from '../models/products';
import { ServiceModel } from '../models/service.model';
import { ConfigurationService } from '../shared/services/configuration.service';
import { JobModel } from '../models/job.model';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private readonly http = inject(HttpClient);
  private readonly configSvc = inject(ConfigurationService);

  
  private backUrl;

  constructor() {
    this.backUrl = `${this.configSvc.productApiUrl}api`;
  }

  // Products

  get(): Observable<Array<ProductModel>> {
    return this.http.get<Array<ProductModel>>(`${this.backUrl}/Products`);
  }

  getProduct(prodId: Guid): Observable<ProductModel> {
    return this.http.get<ProductModel>(`${this.backUrl}/Products/${prodId}`);
  }
  
  deleteProduct(prodId: Guid): Observable<ProductModel> {
    return this.http.delete<ProductModel>(`${this.backUrl}/Products/${prodId}`);
  }
  
  getBySubCategory(subCategory: Guid): Observable<Array<ProductModel>> {
    return this.http.get<Array<ProductModel>>(`${this.backUrl}/Products?subcategoryId=${subCategory.toString()}`);
  }

  post(model: ProductModel): Observable<any> {
    return this.http.post(`${this.backUrl}/Products`, model);
  }

  patch(model: ProductModel): Observable<any> {
    return this.http.patch(`${this.backUrl}/Products/${model.id}`, model);
  }

  search(prodName: string, subcat?: JobModel): Observable<ProductModel[]> {
    let subCategoryFilter = subcat ? `&SubCategoryId?=${subcat}` : '';
    return this.http.get<ProductModel[]>(`${this.backUrl}/products/suggestions?name=${prodName}${subCategoryFilter}`);
  }

  // Services

  getService(id: Guid): Observable<ServiceModel> {
    return this.http.get<ServiceModel>(`${this.backUrl}/Services/${id.toString()}`);
  }

  getServices(): Observable<Array<ServiceModel>> {
    return this.http.get<Array<ServiceModel>>(`${this.backUrl}/Services`);
  }

  saveService(model: ServiceModel): Observable<any> {
    return this.http.post(`${this.backUrl}/Services`, model);
  }

  updateService(model: ServiceModel): Observable<any> {
    return this.http.patch(`${this.backUrl}/Services/${model.id}`, model);
  }
  
  deleteService(serviceId: Guid): Observable<any> {
    return this.http.delete(`${this.backUrl}/Services/${serviceId}`);
  }

  // Quality

  getProductQualityList(): Observable<ProductQualityModel[]> {
    return this.http.get<ProductQualityModel[]>(`${this.backUrl}/Products/ProductQualitys`);
  }
}
